import { render, staticRenderFns } from "./ErrorState.vue?vue&type=template&id=40a06ff0"
import script from "./ErrorState.vue?vue&type=script&lang=ts"
export * from "./ErrorState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports